module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_7.d47969fa.png";